import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable()
export class SEOService {
  constructor(private meta: Meta) {

  }

  getMetaTags() {
    const els: HTMLMetaElement[] = this.meta.getTags('name');
    // els.forEach(el => {
    //   console.log(el);
    //   console.log(el.name);
    //   console.log(el.content);
    // });
  }

  updateMeta(title, description, image) {
    this.meta.updateTag({property: 'og:title', content: title});
    this.meta.updateTag({property: 'og:description', content: description});
    this.meta.updateTag({property: 'og:image', content: image});
  }
}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/services/seoservice.service.ts